export const courseTemplatesI18n = {
  en: {
    gradeFilter: 'Grade filter',
    itemMenu: {
      getTemplate: 'Get Template',
      publish: 'Publish',
      sharedWithMe: 'Shared with me',
      purchased: 'Purchased',
      owner: 'Owner'
    },
    courseCreated: {
      title: 'Success',
      body: 'The subject was created'
    },
    emptyState: {
      message: 'There aren\'t templates in this section now. You can create one in My Content section and publish here',
      action: 'Go to My Content'
    },
    viewTemplate: {
      emptySections: 'You don\'t have sections in this template'
    },
    createCourseTemplate: {
      suggestedGradeLevel: 'Suggested Grade Level',
      actualGradeLevel: 'Actual Grade Level',
      schoolCalendar: 'School Calendar',
      updateTemplate: 'Update the {templateName} template',
      createTemplate: 'Create template',
      subjectTeachingPeriod: 'Subject Teaching Period',
      info: {
        suggestedGradeLevelInfo: 'This course\'s suggested grade level.',
        actualGradeLevelInfo: 'Student\'s current grade level.',
        subjectTeachingPeriodInfo: 'In which period will this subject be taught.'
      },
      folder: {
        noautomatic: 'No automatic folders',
        automaticweek: 'Automatic folders for weeks',
        automaticmonth: 'Automatic folders for months and weeks'
      },
      components: 'Components',
      componentsWarning: 'This action can delete all the rules applied'
    },
    publishTemplate: {
      confirmUpdateTemplate: 'Update the visibility of your previously published template. \n Please select the new visibility option for the template:'
    },
    buyTemplate: {
      confirmTitle: 'Template acquired successfully',
      confirmBody: 'You can see your purchased templates in My Content - Templates.'
    },
    templateAdmin: {
      shareTemplate: 'Share Template',
      blockTemplate: 'Block Template for sharing',
      info: {
        confirmChangeOwner: 'Are you sure you want to update the template {courseName} owner to {owner}',
        shareTemplateInfo: 'You can change the owner and share the template {template} with the users listed bellow',
        blockTemplateInfo: 'Check to block users the options to update the owner or invite co-editors to the template.',
      },
      success: {
        ownerUpdated: 'The template owner was updated successfully',
        templateBlocked: 'Template blocked successfully',
        templateUnblocked: 'Template unblocked successfully'
      },
      errors: {
        ownerNoUpdated: 'The template owner could not update successfully',
        templateNoBlocked: 'The template could not be blocked successfully',
        templateNoUnblocked: 'The template could not be unblocked successfully'
      }
    },
    errors: {
      errorLoadingCourseTemplate: 'Sorry, there was an error trying to load the template.',
      errorSavingTemplate: 'Sorry, there was an error trying to save the template.',
      cantPublishTitle: 'Can\'t publish template',
      cantPublish: 'You cannot publish a template without content.',
      calendarError: 'This calendar cannot be selected.'
    }
  },
  es: {
    gradeFilter: 'Filtro de grado',
    itemMenu: {
      getTemplate: 'Adquirir plantilla',
      publish: 'Publicar',
      sharedWithMe: 'Compartido conmigo',
      purchased: 'Comprado',
      owner: 'Propietario'
    },
    courseCreated: {
      title: 'Completado',
      body: 'El curso fue creado'
    },
    emptyState: {
      message: 'No tiene plantillas de curso en esta sección ahora. Puede crear una desde la sección de Mi Contenido',
      action: 'Ir a Mi Contenido'
    },
    viewTemplate: {
      emptySections: 'No tienes secciones en este template'
    },
    createCourseTemplate: {
      suggestedGradeLevel: 'Grado sugerido',
      actualGradeLevel: 'Grado actual',
      schoolCalendar: 'Calendario Escolar',
      updateTemplate: 'Actualizar la plantilla {templateName}',
      createTemplate: 'Crear plantilla nueva',
      subjectTeachingPeriod: 'Periodo del curso',
      info: {
        suggestedGradeLevelInfo: 'Grado sugerido para este curso.',
        actualGradeLevelInfo: 'Grado actual de los estudiantes.',
        subjectTeachingPeriodInfo: 'El periodo en que el curso se dictará.'
      },
      folder: {
        noautomatic: 'Carpetas no automaticas',
        automaticweek: 'Carpetas automaticas por semana',
        automaticmonth: 'Carpetas automaticas por mes y semana'
      },
      components: 'Componentes',
      componentsWarning: 'Esta acción puede borrar todas las reglas aplicadas'
    },
    publishTemplate: {
      confirmUpdateTemplate: 'Actualizar la visibilidad de su plantilla publicada previamente. \n Por favor seleccione el tipo de visibilidad que tendrá la plantilla:'
    },
    buyTemplate: {
      confirmTitle: 'Plantilla adquirida con éxito',
      confirmBody: 'Puede ver sus plantillas compradas en la sección de Plantillas en Mi Contenido.'
    },
    templateAdmin: {
      shareTemplate: 'Compartir Plantilla',
      blockTemplate: 'Bloquear plantilla para compartir',
      info: {
        confirmChangeOwner: 'Está seguro de que desea cambiar el propietario de la plantilla {courseName} por {owner}',
        shareTemplateInfo: 'Puede cambiar el propietario y compartir la plantilla {template} con los usuarios listados aquí.',
        blockTemplateInfo: 'Habilita para bloquear a usuarios las opciones de cambiar el propietario e invitar co-editores a la plantilla.',
      },
      success: {
        ownerUpdated: 'El propietario de la plantilla fue actualizado con éxito',
        templateBlocked: 'La plantilla fue bloqueada con éxito',
        templateUnblocked: 'La plantilla fue desbloqueada con éxito'
      },
      errors: {
        ownerNoUpdated: 'El propietario de la plantilla no pudo ser actualizado',
        templateNoBlocked: 'La plantilla no pudo ser bloqueada',
        templateNoUnblocked: 'La plantilla no pudo ser desbloqueada'
      }
    },
    errors: {
      errorLoadingCourseTemplate: 'Hubo un error intentando cargar la información de la plantilla de curso.',
      errorSavingTemplate: 'Hubo un error intentando guardar la plantilla de curso.',
      cantPublishTitle: 'No puede publicar el template',
      cantPublish: 'No puede publicar un template sin contenido.',
      calendarError: 'Este calendario no puede ser seleccionado.'
    }
  }
};